export default __webpack_public_path__ + "static/media/page-background.64f41e9a.jpg";